import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class VerisoulService {

  constructor() { }

  async getVerisoulSessionId() {
    for (let attempt = 1; attempt <= 3; attempt++) {
      try {
        const session = await Promise.race([
          (window as any).Verisoul.session(),
          new Promise((_, reject) => setTimeout(() => reject(new Error('Verisoul session timeout')), 5000))
        ]);
        if (session?.session_id) {
          return session.session_id;
        }
      } catch (e) {
        console.log('Verisoul failed get session_id', attempt, e);
      }
    }
    return null;
  }
}
